import NewsBuilder from './NewsBuilder';

export default NewsBuilder;
